import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createEcomSubSubCategory = (_, params) => {
    return Api(endPoints.subSubCategory, params, requestType.POST);
};

const getAllEcomSubSubCategory = (name, categoryId = "All", subCategoryId = "All", lang = "") => {

    const queryParams = new URLSearchParams();
    if (name) queryParams.append("name", name);
    if (categoryId) queryParams.append("categoryId", categoryId);
    if (subCategoryId) queryParams.append("subCategoryId", subCategoryId);
    if (lang) queryParams.append("lang", lang);

    const finalUrl = queryParams.toString() ? `${endPoints.subSubCategory}?${queryParams.toString()}` : endPoints.subSubCategory;

    return Api(finalUrl, null, requestType.GET);
};

const updateEcomSubSubCategory = (id, params) => {
    return Api(`${endPoints.subSubCategory}/${id}`, params, requestType.PUT);
};

const updateEcomSubSubCategoryStatus = (id, params) => {
    return Api(`${endPoints.subSubCategory}/${id}`, params, requestType.PATCH);
};

const deleteEcomSubSubCategory = (id) => {
    return Api(`${endPoints.subSubCategory}/${id}`, null, requestType.DELETE);
};

export {
    createEcomSubSubCategory,
    getAllEcomSubSubCategory,
    updateEcomSubSubCategory,
    updateEcomSubSubCategoryStatus,
    deleteEcomSubSubCategory,
};
